import React, { useState } from "react";
import { FiEye, FiSearch } from "react-icons/fi";

export default function BestsellersReports() {
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    orderStatus: "All",
    paymentStatus: "All",
    category: "All",
    manufacturer: "All",
    billingCountry: "All",
    vendor: "All",
  });

  const bestsellers = [
    { name: "Vintage Style Engagement Ring", quantity: 1, amount: 2100.0 },
    { name: "Apple iCam", quantity: 1, amount: 1300.0 },
    { name: "Leica T Mirrorless Digital Camera", quantity: 1, amount: 530.0 },
    { name: "Flower Girl Bracelet", quantity: 1, amount: 360.0 },
    { name: "First Prize Pies", quantity: 1, amount: 51.0 },
    { name: "Levi’s 511 Jeans", quantity: 1, amount: 43.5 },
    { name: "Fahrenheit 451 by Ray Bradbury", quantity: 1, amount: 27.0 },
    { name: "$25 Virtual Gift Card", quantity: 1, amount: 25.0 },
    { name: "Pride and Prejudice", quantity: 1, amount: 24.0 },
    { name: "If You Wait (donation)", quantity: 1, amount: 23.0 },
    { name: "Science & Faith", quantity: 1, amount: 3.0 },
    { name: "Night Visions", quantity: 1, amount: 2.8 },
  ];

  const total = bestsellers.reduce((sum, b) => sum + b.amount, 0);

  return (
    <div className="p-4 md:p-6 bg-gray-50 min-h-screen">
      <h1 className="text-xl font-semibold text-gray-800 mb-4">Bestsellers</h1>

      {/* Search and Filters */}
      <div className="bg-white p-4 rounded-lg shadow-sm mb-6">
        <div className="flex items-center mb-4 gap-2">
          <FiSearch className="text-gray-500" />
          <span className="text-gray-700 font-medium">Search</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          <div>
            <label className="text-sm text-gray-600">Start date</label>
            <input
              type="date"
              className="w-full border border-gray-300 rounded-md px-3 py-2"
              value={filters.startDate}
              onChange={(e) =>
                setFilters({ ...filters, startDate: e.target.value })
              }
            />
          </div>
          <div>
            <label className="text-sm text-gray-600">End date</label>
            <input
              type="date"
              className="w-full border border-gray-300 rounded-md px-3 py-2"
              value={filters.endDate}
              onChange={(e) =>
                setFilters({ ...filters, endDate: e.target.value })
              }
            />
          </div>
          <div>
            <label className="text-sm text-gray-600">Order status</label>
            <select
              className="w-full border border-gray-300 rounded-md px-3 py-2"
              value={filters.orderStatus}
              onChange={(e) =>
                setFilters({ ...filters, orderStatus: e.target.value })
              }
            >
              <option>All</option>
              <option>Pending</option>
              <option>Completed</option>
            </select>
          </div>
          <div>
            <label className="text-sm text-gray-600">Payment status</label>
            <select
              className="w-full border border-gray-300 rounded-md px-3 py-2"
              value={filters.paymentStatus}
              onChange={(e) =>
                setFilters({ ...filters, paymentStatus: e.target.value })
              }
            >
              <option>All</option>
              <option>Paid</option>
              <option>Unpaid</option>
            </select>
          </div>
          <div>
            <label className="text-sm text-gray-600">Category</label>
            <select className="w-full border border-gray-300 rounded-md px-3 py-2">
              <option>All</option>
            </select>
          </div>
          <div>
            <label className="text-sm text-gray-600">Manufacturer</label>
            <select className="w-full border border-gray-300 rounded-md px-3 py-2">
              <option>All</option>
            </select>
          </div>
          <div>
            <label className="text-sm text-gray-600">Billing country</label>
            <select className="w-full border border-gray-300 rounded-md px-3 py-2">
              <option>All</option>
            </select>
          </div>
          <div>
            <label className="text-sm text-gray-600">Vendor</label>
            <select className="w-full border border-gray-300 rounded-md px-3 py-2">
              <option>All</option>
            </select>
          </div>
        </div>

        <div className="mt-4">
          <button className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700">
            Run report
          </button>
        </div>
      </div>

      {/* Learn more */}
      <a
        href="#"
        className="text-blue-600 text-sm hover:underline mb-4 inline-block"
      >
        Learn more about reports
      </a>

      {/* Table */}
      <div className="overflow-x-auto bg-white rounded-lg shadow-sm">
        <table className="min-w-full text-sm text-left">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="py-3 px-4 font-medium">Name</th>
              <th className="py-3 px-4 font-medium">Total quantity</th>
              <th className="py-3 px-4 font-medium">Total amount (excl tax)</th>
              <th className="py-3 px-4 font-medium text-center">View</th>
            </tr>
          </thead>
          <tbody>
            {bestsellers.map((item, i) => (
              <tr key={i} className="border-t hover:bg-gray-50">
                <td className="py-3 px-4">{item.name}</td>
                <td className="py-3 px-4">{item.quantity}</td>
                <td className="py-3 px-4">${item.amount.toFixed(2)}</td>
                <td className="py-3 px-4 text-center">
                  <button className="flex items-center gap-1 bg-gray-100 hover:bg-gray-200 text-gray-700 text-sm px-3 py-1 rounded">
                    <FiEye />
                    View
                  </button>
                </td>
              </tr>
            ))}
            <tr className="border-t bg-gray-50 font-medium">
              <td className="py-3 px-4 text-right" colSpan="2">
                Total:
              </td>
              <td className="py-3 px-4">${total.toFixed(2)}</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex flex-col md:flex-row items-center justify-between mt-4 text-sm text-gray-600">
        <div className="flex items-center gap-2 mb-2 md:mb-0">
          <button className="px-3 py-1 border rounded hover:bg-gray-100">
            Previous
          </button>
          <span>1</span>
          <button className="px-3 py-1 border rounded hover:bg-gray-100">
            Next
          </button>
        </div>
        <div className="flex items-center gap-2">
          <span>Show</span>
          <select className="border border-gray-300 rounded-md px-2 py-1">
            <option>15</option>
            <option>30</option>
            <option>50</option>
          </select>
          <span>items</span>
        </div>
        <p>1–12 of 12 items</p>
      </div>
    </div>
  );
}
